/**
 * PM 狀態 → StatusDot 色調對照（docs/介面優化.md R6，全 PM 只在這裡定義一次）
 * success 完成、warning 暫停、danger 受阻、neutral 未開始／取消、accent 進行中
 */
import type { StatusTone } from '@redpanda/ui';

export const projectTone: Record<string, StatusTone> = {
  PLANNING: 'neutral',
  IN_PROGRESS: 'accent',
  ON_HOLD: 'warning',
  DELIVERED: 'success',
  COMPLETED: 'success',
  CANCELLED: 'neutral',
};

/** 任務狀態（看板欄頭、我的任務） */
export const taskTone: Record<string, StatusTone> = {
  PENDING: 'neutral',
  IN_PROGRESS: 'accent',
  COMPLETED: 'success',
  BLOCKED: 'danger',
};

/** 里程碑狀態（客戶驗收頁） */
export const milestoneTone: Record<string, StatusTone> = {
  PENDING: 'neutral',
  IN_PROGRESS: 'accent',
  COMPLETED: 'success',
  OVERDUE: 'danger',
};

/** 變更單：待客戶確認＝黃（等回覆）、核准＝綠、拒絕＝灰 */
export const changeOrderTone: Record<string, StatusTone> = {
  PENDING: 'warning',
  APPROVED: 'success',
  REJECTED: 'neutral',
};

/** 優先級：色點＋字，不用彩色方塊（§3-10） */
export const priorityTone: Record<string, StatusTone> = {
  HIGH: 'danger',
  MEDIUM: 'warning',
  LOW: 'neutral',
};

/** 應收帳款：可請款＝主題色（該動作了）、逾期＝紅、未到期＝灰 */
export const receivableTone: Record<string, StatusTone> = {
  PAYMENT_OVERDUE: 'danger',
  BILLABLE: 'accent',
  INVOICED: 'success',
  OVERDUE: 'warning',
  UPCOMING: 'neutral',
};

export const toneOf = (map: Record<string, StatusTone>, value?: string): StatusTone =>
  (value && map[value]) || 'neutral';
